var React = require('react');

function LiveVideo (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","d":"M14 2.7H2c-.7 0-1.3.6-1.3 1.5v7.6c0 1 .6 1.5 1.3 1.5h12c.7 0 1.3-.6 1.3-1.5V4.2c0-1-.6-1.5-1.3-1.5zm0 9.3H2V4h12v8zm-3.3-4L6 10.7V5.3L10.7 8z"}));
}

LiveVideo.defaultProps = {"width":"50","height":"50","viewBox":"0 0 16 16"};

module.exports = LiveVideo;

LiveVideo.default = LiveVideo;
